<div class="modal-header">
    <h4
        class="modal-title pull-left"
    >{{ 'RESTRICTIONS_FOR_TASK_TITLE' | translate: {value: taskId} }}</h4>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="container-flex">
        @if (requiredEmployees && requiredEmployees.length > 0) {
            <div>
                <div class="mb-3">
                    <b>{{ 'REQUIRED_EMPLOYEES' | translate }}</b>
                </div>
                @for (employee of requiredEmployees; track employee) {
                    <ul>
                        <li>{{ employee }}</li>
                    </ul>
                }
            </div>
        }
        @if (restrictedEmployees && restrictedEmployees.length > 0) {
            <div>
                <div class="mb-3">
                    <b>{{ 'RESTRICTED_EMPLOYEES' | translate }}</b>
                </div>
                @for (employee of restrictedEmployees; track employee) {
                    <ul>
                        <li>{{ employee }}</li>
                    </ul>
                }
            </div>
        }
    </div>
</div>
